import cloneDeep from 'lodash/cloneDeep'

import { t } from 'app/i18n'
import { getColor, isDark } from 'app/style'

/**
 * 根据任务状态获取进度值
 * @param {string} status 任务状态
 * @returns number
 */
export const TaskStatus2Percent = (status) => {
  switch (status) {
    case 'waiting':
    case 'pending':
      return 20
    case 'scanning':
    case 'static_dispatch_waiting':
      return 30
    case 'policy_running':
    case 'dynamic_pending':
    case 'scanning_completed':
    case 'dynamic_dispatch_waiting':
      return 40
    case 'running':
      return 60
    case 'processing':
      return 70
    case 'completed':
      return 80
    case 'reported':
      return 100
    case 'failed':
    case 'failed_processing':
    case 'failed_analysis':
      return -1
    default:
      return 100
  }
}
/**
 * 将任务详情中获取的任务信息转换成前端支持的格式
 * @param {*} params 任务详情中获取到的配置信息
 */
export const generateReportConfigParams = (params) => {
  const deepParams = cloneDeep(params)
  if (deepParams.file_in_zip) {
    deepParams.in_zip = deepParams.file_in_zip
    deepParams.type_in_zip = 'file_in_zip'
  } else if (deepParams.type_in_zip) {
    deepParams.in_zip = deepParams.type_in_zip
    deepParams.type_in_zip = 'type_in_zip'
  } else if (deepParams.md5_in_zip) {
    deepParams.in_zip = deepParams.md5_in_zip
    deepParams.type_in_zip = 'md5_in_zip'
  } else {
    deepParams.type_in_zip = 'auto_setup'
  }
  return deepParams
}
/**
 * 引擎判定 根据数值组装html
 * @param {*} score number
 */
export const getThreatLevelTag = (score) => {
  let obj = {}
  switch (score) {
    case 70:
      obj = { name: t('risk.malice'), type: 'red', color: '#ff6a63', bgColor: '#ff76701a' }
      break
    case 50:
      obj = { name: t('risk.suspicious'), type: 'orange', color: '#d9b12f', bgColor: '#c2aa6f1a' }
      break
    case 40:
      obj = { name: t('risk.not_detected'), type: '', color: '#7E7F86', bgColor: getColor('--color-bg-3') }
      break
    case 10:
      obj = { name: t('risk.safe'), type: 'green', color: '#1fbe64' }
      break
    default:
      obj = { name: t('risk.not_detected'), type: '', color: isDark() ? '#b8bbcc' : '#525966' }
      break
  }
  return `<span
    style="
      border: 1px solid ${obj.color};
      background-color: ${obj.bgColor};
      display: inline-block;
      padding: 0 10px;
      font-size: 12px;
      text-align: center;
      border-radius: 2px;
      color: ${obj.color};
      line-height: 20px;
  ">${obj.name}</span>`
}
